import * as React from 'react';
import { LoaderScreen } from '@grandvisionhq/common';
import useAppointmentSessionState from '../../hooks/use-appointment-session-state.js';
import { useRoutingContext } from '../../pages/BookAppointment/context/RoutingContext/context.js';

const ClientSessionManager = ({ children , initialRoute ,  })=>{
    const [{ goTo  }, { queryParams , currentRoute  }] = useRoutingContext();
    const { getAppointmentSessionState , setAppointmentSessionState , removeAppointmentSessionState  } = useAppointmentSessionState();
    // In order to do a redirect, the following conditions should be met.
    // 1. Only execute on book-appointmentv3 without subroute
    // 2. Customer session storage 'currentRoute' should not be an empty string
    // 3. No query parameters are allowed in the URL
    // 4. There should be a minimum of one query param stored in the session storage
    const shouldRedirect = React.useMemo(()=>{
        const appointmentSessionState = getAppointmentSessionState();
        const hasQueryParams = Object.keys(queryParams).length;
        const hasSessionStateQueryParams = appointmentSessionState && Object.keys(appointmentSessionState.queryParams).length;
        const isFirstStep = currentRoute === '';
        if (isFirstStep && !hasQueryParams && hasSessionStateQueryParams && appointmentSessionState.currentRoute !== initialRoute) {
            return true;
        }
        return false;
    }, [
        currentRoute,
        getAppointmentSessionState,
        initialRoute,
        queryParams
    ]);
    React.useEffect(()=>{
        const redirectUser = ()=>{
            const appointmentSessionState = getAppointmentSessionState();
            if (shouldRedirect && appointmentSessionState) {
                goTo(appointmentSessionState.currentRoute, appointmentSessionState.queryParams);
            }
        };
        // Reset state when user arrives at conformation page
        // Store appointment state in session storage on every step except for first one
        // Redirect when on first step and conditions are met
        if (currentRoute === 'confirmation') {
            removeAppointmentSessionState();
        } else if (currentRoute !== '') {
            setAppointmentSessionState();
        } else if (currentRoute === '') {
            redirectUser();
        }
    }, [
        currentRoute,
        getAppointmentSessionState,
        goTo,
        removeAppointmentSessionState,
        setAppointmentSessionState,
        shouldRedirect, 
    ]);
    // We need a div here, otherwise the parent div of the loader will dissappear during loading state
    if (shouldRedirect) {
        return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(LoaderScreen, null));
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
};
ClientSessionManager.displayName = 'ClientSessionManager';
var ClientSessionManager$1 = ClientSessionManager;

export { ClientSessionManager$1 as default };
//# sourceMappingURL=ClientSessionManager.js.map
